package com.hyperether.goodjob.scenes.notifications

import androidx.lifecycle.ViewModel
import com.hyperether.goodjob.repository.Repository

class NotificationsViewModel(val repository: Repository) : ViewModel()